module.exports = __webpack_public_path__ + "static/media/2.23982b75.png";